module.exports = __webpack_public_path__ + "img/vlog.37baca58.gif";